<div class="fuse-horizontal-navigation-wrapper">
    <button class="dashboard-btn font-semibold text-lg h-[36px] hover:bg-white/10 px-[10px] py-0.5 rounded-full flex gap-[16px] items-center" (click)="showDashboard()">
        <span class="whitespace-pre-wrap">{{ menuTitle }}</span>
       <img src="images/navigation/chevron.svg" alt="" class="w-4 h-4 fill-white">
    </button>
    @if(showDashboardItems){
    <div class="popup-dashboard" class="absolute top-[56px] left-[178px] bg-white text-black fill-black !rounded-md border border-white shadow-card-button">
        <div class="backdrop fixed top-0 bottom-0 left-0 right 0 w-full" (click)="showDashboard()"></div>
        <div class="scroll-holder">
            <div class="nav-menu-content py-[10px]">
                <div class="nav-menu-content w-[258px]">
                    @for (item of navigation; track trackByFn($index, item)) {
                        @if ((item.hidden && !item.hidden(item)) || !item.hidden) {
                            <sidebar-item [item]="item"></sidebar-item>
                        }
                    }
                </div>
            </div>
        </div>
    </div>
    }
</div>
